import { useState } from 'react'
import { RequirementDirection, Department } from "../../types/data";
import RowBlock from '../row-block/row-block';
import { arrow } from "../../../vpo/ui-icons/icons";
import { calculatesAverageValue, getDateAsString } from '../../utils/utils';
import { QuarterDictionary } from '../../types/data';

type DirectionBlockProps = RequirementDirection & {
  departments: Department[];
}

const COLUMNS = {
  '1': {
    width: '60px',
    indent: '0',
  },
  '2': {
    width: '70px',
    indent: '60px',
  },
  '3': {
    width: '70px',
    indent: '130px',
  },
  '4': {
    width: '120px',
    indent: '200px',
  },
  '5': {
    width: '170px',
    indent: '320px',
  },
  '6': {
    width: '110px',
    indent: '490px',
  },
};

function DirectionBlock(props: DirectionBlockProps) {
  const { year, quarter, factory, title, direction, departments, completedAssessment, completionDate } = props;

  const [isOpen, setIsOpen] = useState(false);

  const handleToggleChange = () => {
    setIsOpen(!isOpen);
  };

  console.log('DirectionBlock', direction)

  return (
    <tbody>
      <tr>
        <td
          className="sticky border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
          style={{
            left: `${COLUMNS['1'].indent}`,
            width: `${COLUMNS['1'].width}`,
          }}
        >
          {year}
        </td>

        <td
          className="sticky border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
          style={{
            left: `${COLUMNS['2'].indent}`,
            width: `${COLUMNS['2'].width}`,
          }}
        >
          {QuarterDictionary[quarter]} кв.
        </td>

        <td
          className="sticky border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
          style={{
            left: `${COLUMNS['3'].indent}`,
            width: `${COLUMNS['3'].width}`,
          }}
        >
          {factory}
        </td>

        <td
          className="sticky border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
          style={{
            left: `${COLUMNS['4'].indent}`,
            width: `${COLUMNS['4'].width}`,
          }}
        >
          {title}
        </td>

        <td
          className="sticky border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
          style={{
            left: `${COLUMNS['5'].indent}`,
            width: `${COLUMNS['5'].width}`,
          }}
          onClick={handleToggleChange}
        >
          <div className={`text-sm ${isOpen ? 'opacity-100' : 'opacity-50'}`}>
            {direction.title}
          </div>

          <div
            className={`absolute right-3 top-[50%] translate-y-[-50%] cursor-pointer ${isOpen && 'rotate-180'}`}
          >
            {arrow}
          </div>
        </td>

        {departments.map((el) => (
          <td
            key={el.id}
            className="border border-gray-400 px-2.5 py-2 text-center text-xs"
          >
            {calculatesAverageValue(direction.blockRequirements, el.title)}
            {Number.isInteger(calculatesAverageValue(direction.blockRequirements, el.title)) && '%'}
          </td>
        ))}

        <td className="border border-gray-400 px-2.5 py-2 text-center text-xs">
          {calculatesAverageValue(direction.blockRequirements, undefined, true)}
          {calculatesAverageValue(direction.blockRequirements, undefined, true) !== 'N/A' && '%'}
        </td>
        <td className="border border-gray-400 px-2.5 py-2 text-center text-xs">{completedAssessment}</td>
        <td className="border border-gray-400 px-2.5 py-2 text-center text-xs">{getDateAsString(completionDate as string)}</td>
      </tr>

      {isOpen &&
        direction.blockRequirements.map((item, index) => (
          <RowBlock
            key={index}
            title={item.title}
            groupRequirements={item.groupRequirements}
            departments={departments}
            factory={factory}
            quarter={quarter}
            year={year}
            gop={title}
            isFactory
            completedAssessment={completedAssessment}
            completionDate={completionDate}
          />
        ))
      }
    </tbody>
  )
}

export default DirectionBlock;
